import FilterDateLastYear from "./FilterDateLastYear";
const FilterNoteDate = (props: any) => {
  const before = props?.before;

  return (
    <FilterDateLastYear
      source="limitNoteDate"
      label="Note Date"
      variant="outlined"
      {...props}
    />
  );
};

export default FilterNoteDate;
